import { message } from "antd";
import { Card, Flex, Typography } from "index";
import React from "react";
type ColorSwatchProps = {
  colorName: string;
  colorValue: string;
};
const ColorSwatch: React.FC<ColorSwatchProps> = ({ colorName, colorValue }) => {
  const [messageApi, contextHolder] = message.useMessage();

  const handleClick = () => {
    navigator.clipboard.writeText(colorValue);
    messageApi.success(`${colorValue} copied to clipboard!`);
  };

  return (
    <>
      {contextHolder}
      <div
        onClick={handleClick}
        style={{
          cursor: "pointer",
          textAlign: "center",
          margin: "8px",
        }}
      >
        <Flex vertical justify="center" align="center">
          <Card
            style={{
              backgroundColor: colorValue,
              height: 60,
              width: 60,
              marginBottom: "1rem",
            }}
            color={colorValue}
          />
          <Typography variant="text" strong>
            {colorName}
          </Typography>
          <Typography variant="text">{colorValue}</Typography>
        </Flex>
      </div>
    </>
  );
};
export default ColorSwatch;
